import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
interface BrokerageLineProps {
  tone?: 'light' | 'dark';
  className?: string;
  /** Include the professional display name before the brokerage name. */
  withName?: boolean;
}

/**
 * The licensed brokerage name must appear adjacent to every contact point.
 */
export function BrokerageLine({
  tone = 'dark',
  className = '',
  withName = true
}: BrokerageLineProps) {
  const {
    t
  } = useLanguage();
  const affiliation = t('Affiliated with Avanti Way Realty LLC', 'Afiliada a Avanti Way Realty LLC');
  return <p className={`text-[11px] leading-relaxed tracking-wide ${tone === 'light' ? 'text-white/70' : 'text-ink/60'} ${className}`} data-id="element-92" data-mp="2lbzipganx0yv">
      {withName ? `Veronica Gomez Santana • ${affiliation}` : affiliation}
    </p>;
}